<div class="dashboard-home">
  <div class="row mt-4">
    <div class="col-lg-8 col-md-12">
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="white_box">
            <div class="d-flex justify-content-between">
              <div class="text-left">
                <h5>Supporters</h5>
                <h1>{{ dashboard?.supporters }}</h1>
              </div>
              <div class="dashboard-icon">
                <i class="fas fa-users"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="white_box">
            <div class="d-flex justify-content-between">
              <div class="text-left">
                <h5>Signup + Referral</h5>
                <h1>{{ dashboard?.user_signup }}</h1>
              </div>
              <div class="dashboard-icon">
                <i class="fas fa-street-view"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="white_box tokens_box mb-4">
        <div class="d-flex space-between card_top">
          <div class="card_title">Supporter List</div>
          <div class="icon">
            <i class="fa fa-users"></i>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Date Joined</th>
                <th>Name</th>
                <th>Email</th>
                <th>Referral Count</th>
                <th>Copy</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let support of supports">
                <td>{{ support.appUser?.created * 1000 | date : "medium" }}</td>
                <td>{{ support.appUser?.profileCharacterName ?? "User" }}</td>
                <td>{{ support.appUser?.memberEmails[0]?.email ?? "-" }}</td>
                <td style="cursor: pointer;"
                  (click)="showReferrals(support.appUser?.appUserReferral, view_all_referrals)">{{
                  support?.appUser?.appUserReferral?.appUserReferralHistories?.length ?? 0 }}</td>
                <td><span (click)="copyString(support.appUser?.memberEmails[0]?.email)"
                    style="cursor: pointer; color: blue"><i class="fa-solid fa-copy"></i> Copy</span></td>
              </tr>

              <tr *ngIf="!supports || supports.length === 0">
                <td colspan="5" class="text-center">No supports found.</td>
              </tr>
            </tbody>
          </table>
          <div class="p-2">
            <button (click)="copyAllEmails()" class="btn"><i class="fa-solid fa-copy"></i> Copy All Emails</button>
          </div>
        </div>
      </div>
      <div class="white_box tokens_box mb-4">
        <div class="d-flex space-between card_top">
          <div class="card_title">New Sign Up + Referral</div>
          <div class="icon">
            <i class="fa fa-users"></i>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Shop Biz Name</th>
                <th>Referral By</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of referralUsers.data">
                <td>{{ user.profileCharacterName || "Unknown" }}</td>
                <td>{{ user.phone || "Unknown" }}</td>
                <td>{{ user.appUserReferralHistory.appUserReferral.shopName }}</td>
                <td>{{ user.appUserReferralHistory.appUserReferral.appUser.profileCharacterName }} - {{
                  user.appUserReferralHistory.appUserReferral.appUser.phone }}</td>
                <td>{{ user.created * 1000 | date : "medium" }}</td>
              </tr>
              <tr *ngIf="!referralUsers.data || referralUsers.data.length === 0">
                <td colspan="5" class="text-center">No referral users found.</td>
              </tr>
            </tbody>
          </table>
          <div class="pagination-container d-flex justify-content-end">
            <div class="pagination">
              <button class="btn btn-sm btn-ligh" (click)="getReferralUsers(referralUsers.currentPage - 1)"
                [disabled]="referralUsers.currentPage === 1">Previous</button>
              <span class="mx-2">Page {{ referralUsers.currentPage }} of {{ referralUsers.totalPages }}</span>
              <button class="btn btn-sm btn-ligh" (click)="getReferralUsers(referralUsers.currentPage + 1)"
                [disabled]="referralUsers.currentPage === referralUsers.totalPages">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="white_box mb-4">
        <div class="title mb-4">
          <h2>Shortcuts</h2>
        </div>
        <div class="row shortcuts-container">
          <div class="icon_img_pl" tooltip="Billing" tooltipPlacement="bottom">
            <img loading="lazy" src="../../../assets/images/new/Icon-01.png" />
            <p class="pt-2">Billing</p>
          </div>

          <a [routerLink]="['/admin/review-info']" class="icon_img_pl" tooltip="Review Manager"
            tooltipPlacement="bottom">
            <img loading="lazy" src="../../../assets/images/new/Icon-02.png" />
            <p class="pt-2">Review Manager</p>
          </a>

          <a [routerLink]="['/admin/sticker-design']" class="icon_img_pl" tooltip="Design Work"
            tooltipPlacement="bottom">
            <img loading="lazy" src="../../../assets/images/new/Icon-03.png" />
            <p class="pt-2">Design Work</p>
          </a>

          <a [routerLink]="['/admin/forms']" class="icon_img_pl" tooltip="Forms" tooltipPlacement="bottom">
            <img loading="lazy" src="../../../assets/images/new/Icon-04.png" />
            <p class="pt-2">Forms</p>
          </a>

          <a [routerLink]="['/admin/mapSearch']" class="icon_img_pl" tooltip="Map Search" tooltipPlacement="bottom">
            <img loading="lazy" src="../../../assets/images/new/Icon-05.png" />
            <p class="pt-2">Map Search</p>
          </a>

          <a [routerLink]="['/admin/shop']" class="icon_img_pl" tooltip="Shop" tooltipPlacement="bottom">
            <img loading="lazy" src="../../../assets/images/new/Icon-06.png" />
            <p class="pt-2">Shop</p>
          </a>

          <a routerLink="/admin/gallery" class="icon_img_pl" tooltip="Gallery" tooltipPlacement="bottom">
            <!-- <i class="fa-image fa-solid"></i> -->
            <svg viewBox="0 0 800 681" fill="none">
              <path
                d="M773.292 0H133.542C118.86 0 106.833 11.8704 106.833 26.7083V53.4166H80.1249C65.4432 53.4166 53.4166 65.287 53.4166 80.1249V106.833H26.7083C12.0266 106.833 0 118.704 0 133.542V653.339C0 668.02 11.8704 680.047 26.7083 680.047H666.458C681.14 680.047 693.167 668.177 693.167 653.339V626.63H719.875C734.557 626.63 746.583 614.76 746.583 599.922V573.214H773.292C787.973 573.214 800 561.343 800 546.505V26.7083C800 11.8704 788.13 0 773.292 0ZM666.615 431.082L596.798 351.113C591.488 345.022 582.116 345.022 576.65 351.113L492.308 447.638L262.397 243.342C257.399 238.813 249.746 238.813 244.748 243.342L27.0207 436.861V146.661C27.0207 139.321 32.9559 133.385 40.2968 133.385H653.339C660.679 133.385 666.615 139.321 666.615 146.661V431.082ZM706.755 599.766H693.479V133.229C693.479 118.547 681.609 106.521 666.771 106.521H80.2811V93.2448C80.2811 85.9039 86.2163 79.9688 93.5572 79.9688H706.599C713.94 79.9688 719.875 85.9039 719.875 93.2448L720.031 586.49C720.031 593.831 714.096 599.766 706.755 599.766ZM760.016 546.349H746.74V79.9688C746.74 65.287 734.869 53.2604 720.031 53.2604H133.542V39.9844C133.542 32.6435 139.477 26.7083 146.818 26.7083H759.859C767.2 26.7083 773.135 32.6435 773.135 39.9844V533.073H773.292C773.292 540.414 767.357 546.349 760.016 546.349Z"
                fill="black" />
              <path
                d="M480.125 213.198C450.761 213.198 426.864 237.095 426.864 266.458C426.864 295.822 450.761 319.719 480.125 319.719C509.488 319.719 533.385 295.822 533.385 266.458C533.385 237.095 509.488 213.198 480.125 213.198Z"
                fill="#1575E8" />
            </svg>
            <p class="pt-2">Gallery</p>
          </a>

          <a routerLink="/admin/voucher" class="icon_img_pl" tooltip="Voucher" tooltipPlacement="bottom">
            <!-- <i class="fa-solid fa-ticket-alt"></i> -->
            <svg viewBox="0 0 734 567" fill="none">
              <path
                d="M683.363 0.0297827H600.03C591.237 0.155018 582.851 3.74931 576.696 10.0298L533.363 53.3631L490.03 10.0298C483.875 3.74931 475.489 0.155018 466.696 0.0297827H50.0298C43.401 -0.203025 36.7952 0.931041 30.6236 3.36139C24.452 5.79174 18.8467 9.46634 14.1565 14.1565C9.46635 18.8467 5.79173 24.452 3.36138 30.6236C0.931037 36.7952 -0.203024 43.401 0.0297828 50.0298V516.696C-0.203024 523.325 0.931037 529.931 3.36138 536.103C5.79173 542.274 9.46635 547.88 14.1565 552.57C18.8467 557.26 24.452 560.934 30.6236 563.365C36.7952 565.795 43.401 566.929 50.0298 566.696H466.696C475.489 566.571 483.875 562.977 490.03 556.696L533.363 513.363L576.696 556.696C582.851 562.977 591.237 566.571 600.03 566.696H683.363C689.992 566.929 696.598 565.795 702.769 563.365C708.941 560.934 714.546 557.26 719.236 552.57C723.927 547.88 727.601 542.274 730.031 536.103C732.462 529.931 733.596 523.325 733.363 516.696V50.0298C733.596 43.401 732.462 36.7952 730.031 30.6236C727.601 24.452 723.927 18.8467 719.236 14.1565C714.546 9.46634 708.941 5.79174 702.769 3.36139C696.598 0.931041 689.992 -0.203025 683.363 0.0297827ZM666.696 500.03H613.363L556.696 443.363C553.73 440.13 550.124 437.549 546.107 435.783C542.091 434.017 537.751 433.105 533.363 433.105C528.975 433.105 524.635 434.017 520.619 435.783C516.602 437.549 512.996 440.13 510.03 443.363L453.363 500.03H66.6965V66.6965H453.363L510.03 123.363C512.996 126.596 516.602 129.178 520.619 130.943C524.635 132.709 528.975 133.621 533.363 133.621C537.751 133.621 542.091 132.709 546.107 130.943C550.124 129.178 553.73 126.596 556.696 123.363L613.363 66.6965H666.696V500.03Z"
                fill="black" />
              <path
                d="M533.363 166.696C524.523 166.696 516.044 170.208 509.793 176.46C503.542 182.711 500.03 191.189 500.03 200.03V233.363C500.03 242.204 503.542 250.682 509.793 256.933C516.044 263.185 524.523 266.696 533.363 266.696C542.204 266.696 550.682 263.185 556.933 256.933C563.185 250.682 566.696 242.204 566.696 233.363V200.03C566.696 191.189 563.185 182.711 556.933 176.46C550.682 170.208 542.204 166.696 533.363 166.696Z"
                fill="#1575E8" />
              <path
                d="M533.363 300.03C524.523 300.03 516.044 303.542 509.793 309.793C503.542 316.044 500.03 324.523 500.03 333.363V366.696C500.03 375.537 503.542 384.015 509.793 390.267C516.044 396.518 524.523 400.03 533.363 400.03C542.204 400.03 550.682 396.518 556.933 390.267C563.185 384.015 566.696 375.537 566.696 366.696V333.363C566.696 324.523 563.185 316.044 556.933 309.793C550.682 303.542 542.204 300.03 533.363 300.03Z"
                fill="#1575E8" />
              <path
                d="M200.03 250.03C218.439 250.03 233.363 235.106 233.363 216.696C233.363 198.287 218.439 183.363 200.03 183.363C181.62 183.363 166.697 198.287 166.697 216.696C166.697 235.106 181.62 250.03 200.03 250.03Z"
                fill="#1575E8" />
              <path
                d="M333.363 383.363C351.773 383.363 366.696 368.439 366.696 350.03C366.696 331.62 351.773 316.696 333.363 316.696C314.954 316.696 300.03 331.62 300.03 350.03C300.03 368.439 314.954 383.363 333.363 383.363Z"
                fill="#1575E8" />
              <path
                d="M326.697 176.696L160.03 343.363C156.797 346.33 154.216 349.935 152.45 353.952C150.684 357.969 149.772 362.309 149.772 366.696C149.772 371.084 150.684 375.424 152.45 379.441C154.216 383.457 156.797 387.063 160.03 390.03C162.996 393.263 166.602 395.844 170.619 397.61C174.636 399.376 178.976 400.288 183.363 400.288C187.751 400.288 192.091 399.376 196.108 397.61C200.124 395.844 203.73 393.263 206.697 390.03L373.363 223.363C378.178 216.944 380.515 209.004 379.946 201C379.377 192.997 375.941 185.467 370.267 179.793C364.593 174.119 357.063 170.682 349.06 170.114C341.056 169.545 333.116 171.882 326.697 176.696Z"
                fill="#1575E8" />
            </svg>

            <p class="pt-2">Voucher</p>
          </a>
          <a routerLink="/admin/cashback" class="icon_img_pl" tooltip="Cashback" tooltipPlacement="bottom">
            <!-- <i class="fa-money-bill-wave fa-solid"></i> -->
            <svg viewBox="0 0 800 800" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M710.498 372.363C694.445 372.363 678.397 378.39 666.308 390.478L592.968 463.867C584.846 451.044 572.202 441.048 556.592 436.865L383.496 390.478C369.7 386.782 355.435 386.087 341.601 388.183C327.767 390.281 314.376 395.166 302.295 402.783L194.238 470.947L185.498 455.762C174.613 436.908 149.615 430.228 130.761 441.113L48.5837 488.525C29.7302 499.41 23.0503 524.408 33.9353 543.262L156.396 755.322C167.281 774.176 192.23 780.904 211.084 770.019L293.261 722.558C312.115 711.673 318.844 686.676 307.959 667.822L306.346 664.99L353.172 633.349L525.438 667.236C549.046 671.877 570.149 665.291 586.961 648.096C642.524 591.264 698.157 534.69 754.588 479.004C754.638 478.971 754.688 478.937 754.738 478.904C778.916 454.726 778.916 414.654 754.738 390.476C742.65 378.387 726.551 372.363 710.498 372.363ZM710.498 421.924C713.616 421.924 716.734 423.229 719.336 425.83C724.538 431.033 724.538 438.352 719.336 443.555C662.597 499.548 606.801 556.334 551.22 613.183C550.2 614.228 536.529 618.444 535.107 618.164L352.636 582.324C349.399 581.684 346.067 581.69 342.832 582.344C339.597 582.998 336.524 584.285 333.789 586.133L281.299 621.631L219.287 514.258L328.955 445.117C341.349 437.303 356.404 434.977 370.556 438.769L543.652 485.156C550.759 487.061 554.394 493.382 552.49 500.488C550.585 507.594 544.264 511.23 537.158 509.326L428.515 480.224C422.112 478.509 415.289 479.408 409.548 482.723C403.806 486.038 399.617 491.497 397.9 497.9C396.185 504.304 397.084 511.126 400.399 516.868C403.713 522.609 409.173 526.799 415.576 528.515L524.218 557.617C548.614 564.154 573.889 554.899 589.013 536.328C591.43 535.223 593.655 533.739 595.605 531.933L701.66 425.83C704.261 423.229 707.38 421.924 710.498 421.924ZM147.168 489.355L159.277 510.351C159.704 513.897 160.886 517.311 162.744 520.361C164.348 522.792 166.364 524.923 168.701 526.66L259.668 684.228L194.726 721.728L82.2263 526.855L147.168 489.355Z"
                fill="black" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M500 225.342C493.37 225.342 487.011 227.975 482.322 232.664C477.634 237.352 475 243.711 475 250.342C475 256.972 477.634 263.331 482.322 268.019C487.011 272.708 493.37 275.342 500 275.342H550C556.63 275.342 562.989 272.708 567.678 268.019C572.366 263.331 575 256.972 575 250.342C575 243.711 572.366 237.352 567.678 232.664C562.989 227.975 556.63 225.342 550 225.342H500Z"
                fill="#1575E8" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M500 125.342C493.37 125.342 487.011 127.975 482.322 132.664C477.634 137.352 475 143.711 475 150.342C475 156.972 477.634 163.331 482.322 168.019C487.011 172.708 493.37 175.342 500 175.342H550C556.63 175.342 562.989 172.708 567.678 168.019C572.366 163.331 575 156.972 575 150.342C575 143.711 572.366 137.352 567.678 132.664C562.989 127.975 556.63 125.342 550 125.342H500Z"
                fill="#1575E8" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M525 25.3418C428.646 25.3418 350 103.989 350 200.342C350 296.696 428.646 375.342 525 375.342C621.354 375.342 700 296.696 700 200.342C700 103.989 621.354 25.3418 525 25.3418ZM525 75.3418C594.332 75.3418 650 131.01 650 200.342C650 269.674 594.332 325.342 525 325.342C455.668 325.342 400 269.674 400 200.342C400 131.01 455.668 75.3418 525 75.3418Z"
                fill="#1575E8" />
            </svg>
            <p class="pt-2">Cashback</p>
          </a>
          <a routerLink="/admin/news" class="icon_img_pl" tooltip="News" tooltipPlacement="bottom">
            <!-- <i class="fa-newspaper fa-solid"></i> -->
            <svg viewBox="0 0 26 22" fill="none">
              <path d="M22 21H4C2.3 21 1 19.7 1 18V1H19V8" stroke="black" stroke-miterlimit="10" />
              <path d="M22 21C20.3 21 19 19.7 19 18V8H25V18C25 19.7 23.7 21 22 21Z" stroke="black"
                stroke-miterlimit="10" />
              <path d="M15 5H5V8H15V5Z" stroke="#1575E8" stroke-width="2" stroke-miterlimit="10" />
              <path d="M4 11H9" stroke="#1575E8" stroke-width="2" stroke-miterlimit="10" />
              <path d="M11 11H16" stroke="#1575E8" stroke-width="2" stroke-miterlimit="10" />
              <path d="M4 14H9" stroke="#1575E8" stroke-width="2" stroke-miterlimit="10" />
              <path d="M11 14H16" stroke="#1575E8" stroke-width="2" stroke-miterlimit="10" />
            </svg>

            <p class="pt-2">News</p>
          </a>
        </div>
      </div>
      <!-- <div class="white_box tokens_box">
        <div class="d-flex space-between card_top">
          <div class="card_title">
            {{ total_txn }}
            <span class="text-small">Available VIP tokens</span>
          </div>
          <div class="icon">
            <i class="fa fa-dollar"></i>
          </div>
        </div>
        <div class="footer_actions">
          <p (click)="managesubscription(2)">Manage Subscription - KaChiing</p>
          <p (click)="managesubscription(1)">Manage Subscription - MYVIP</p>
          <p (click)="view_all_transactions(view_all_transactions_popup)">View all transactions</p>
        </div>
      </div> -->
    </div>

    <div class="col-lg-4 col-md-12">
      <div class="white_box mb-4">
        <div class="title mb-4">
          <h2>Details</h2>
        </div>
        <div class="card_list">
          <ul class="">
            <li><i class="fa-solid fa-circle-check pr-3"></i>Top Up Credits for VIP token deductions</li>
            <li><i class="fa-solid fa-circle-check pr-3"></i>Please check details before deductions</li>
            <li><i class="fa-solid fa-circle-check pr-3"></i> Deductions are non-refundable</li>
            <li><i class="fa-solid fa-circle-check pr-3"></i>MYVIP has the right to change any terms without prior
              communication</li>
          </ul>
        </div>
      </div>

      <div class="white_box mb-4">
        <div class="d-flex space-between info-box">
          <div class="circle_icon">
            <i class="fa-solid fa-table-cells"></i>
          </div>
          <h3 class="heading_mid ml-3 m-0">
            <div class="heading_mid-title" (click)="dropdownPrice = !dropdownPrice">
              Monthly Base Rate
              <i class="fa-solid fa-angle-down"></i>
            </div>
            <p>Pay for your monthly base rate on a subscription basis</p>
          </h3>
        </div>
        <div class="my-dropdown" [class.active]="dropdownPrice">
          <div class="mt-4 d-flex space-between card_top">
            <div class="card_title">
              {{ total_txn }}
              <span class="text-small">Available VIP tokens</span>
            </div>
            <div class="icon">
              <i class="fa fa-dollar"></i>
            </div>
          </div>
          <div class="footer_actions">
            <p (click)="managesubscription(2)">Manage Subscription - KaChiing</p>
            <p (click)="managesubscription(1)">Manage Subscription - MYVIP</p>
            <p (click)="view_all_transactions(view_all_transactions_popup)">View all transactions</p>
          </div>
        </div>
      </div>


      <div class="white_box mb-4">
        <div class="d-flex space-between info-box">
          <div class="circle_icon">
            <i class="fa-solid fa-chart-line"></i>
          </div>
          <h3 class="heading_mid ml-3 m-0">
            Additional Modules
            <p>Customized modules require credits to upgrade</p>
          </h3>
        </div>
      </div>
    </div>
  </div>
  <div class="logos">
    <div class="logos__title">Brands That Matter</div>
    <app-my-carousel-swiper [config]="carouselOptionsLogos">
      <div class="swiper-slide" *ngFor="let brand of brands">
        <div class="logos__card">
          <div class="image"><img loading="lazy" [src]="imgUrl + brand.image" alt="" /></div>
          <div class="title">{{ brand.name }}</div>
          <div class="brand-title mt-2">{{ brand?.title }}</div>
        </div>
      </div>
    </app-my-carousel-swiper>
  </div>
</div>

<ng-template #view_all_transactions_popup let-modal>
  <button type="button" class="close close_modal" style="outline: none" (click)="modal.dismiss('Cross click')"
    data-dismiss="modal"><span aria-hidden="true">×</span></button>

  <div class="modal-header">
    <h5 class="modal_title">VIP Tokens Report</h5>
  </div>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-md-12 add_ded_tbl">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Detail</th>
              <th scope="col">VIP Tokens</th>
              <th scope="col">Txn. Status</th>
              <th scope="col">Ded. From</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of transactions; let a = index">
              <th scope="row">{{ a + 1 }}</th>
              <td>
                <span *ngIf="i.add_deduct == 'add'">Add VIP Token</span>
                <span *ngIf="i.add_deduct == 'deduct'">Deduct VIP Token</span>
              </td>
              <td>{{ i.tokens }}</td>
              <td>
                <span *ngIf="i.add_deduct == 'add'">{{ i.status }}</span>
                <span *ngIf="i.add_deduct == 'deduct'">complete</span>
              </td>
              <td>
                <span *ngIf="i.type == 0"><i class="fas fa-coins"></i></span>
                <span *ngIf="i.type == 1"><i class="fab fa-google"></i></span>
                <span *ngIf="i.type == 2"><i class="fab fa-instagram"></i></span>
                <span *ngIf="i.type == 3"><i class="fab fa-twitter"></i></span>
                <span *ngIf="i.type == 4"> GM {{ i.show }} </span>
                <span *ngIf="i.type == 5"> ST {{ i.show }} </span>
                <span *ngIf="i.type == 6"> {{ i.show }} </span>
              </td>
              <td>{{ i.created * 1000 | date : "medium" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #view_all_referrals let-modal>
  <button type="button" class="close close_modal" style="outline: none" (click)="modal.dismiss('Cross click')"
    data-dismiss="modal"><span aria-hidden="true">×</span></button>

  <div class="modal-header">
    <h5 class="modal_title">Referrals</h5>
  </div>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-md-12 add_ded_tbl">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">No.</th>
              <th>Date Joined</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of referrals; let a = index">
              <td scope="row">{{ a + 1 }}</td>

              <td>{{i.created * 1000 | date : "medium"}}</td>
              <td>{{i.profileCharacterName || 'Unknown'}}</td>
              <td>{{i.email || 'Unknown'}}</td>
              <td>{{i.phone || 'Unknown'}}</td>
            </tr>
            <tr *ngIf="referrals.length < 1">
              <th colspan="4">No Referrals Yet</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>